'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _AppInitContainer = require('./AppInitContainer');

var _AppInitContainer2 = _interopRequireDefault(_AppInitContainer);

var _WorkspaceInitContainer = require('./../workspace/WorkspaceInitContainer');

var _WorkspaceInitContainer2 = _interopRequireDefault(_WorkspaceInitContainer);

var _Login = require('../auth/modals/login/Login');

var _Login2 = _interopRequireDefault(_Login);

var _Register = require('../auth/modals/register/Register');

var _Register2 = _interopRequireDefault(_Register);

var _ForgottenPasswordModal = require('../auth/modals/forgottenPassword/ForgottenPasswordModal');

var _ForgottenPasswordModal2 = _interopRequireDefault(_ForgottenPasswordModal);

var _ChangePasswordModal = require('../auth/modals/changePassword/ChangePasswordModal');

var _ChangePasswordModal2 = _interopRequireDefault(_ChangePasswordModal);

var _StaticPage = require('../components/static/StaticPage');

var _StaticPage2 = _interopRequireDefault(_StaticPage);

var _CurrentBoardIdSynchroniser = require('./CurrentBoardIdSynchroniser');

var _CurrentBoardIdSynchroniser2 = _interopRequireDefault(_CurrentBoardIdSynchroniser);

var _EmailUnsubscribeFullscreenModal = require('./../user/account/settings/EmailUnsubscribeFullscreenModal');

var _EmailUnsubscribeFullscreenModal2 = _interopRequireDefault(_EmailUnsubscribeFullscreenModal);

var _Payment = require('./../user/account/payment/Payment');

var _Payment2 = _interopRequireDefault(_Payment);

var _CurrentPlan = require('./../user/account/plan/CurrentPlan');

var _CurrentPlan2 = _interopRequireDefault(_CurrentPlan);

var _AccountSettingsModal = require('../user/account/settings/AccountSettingsModal');

var _AccountSettingsModal2 = _interopRequireDefault(_AccountSettingsModal);

var _UpdateCardModal = require('../user/account/updateCard/UpdateCardModal');

var _UpdateCardModal2 = _interopRequireDefault(_UpdateCardModal);

var _TeamManagement = require('../user/account/team/TeamManagement');

var _TeamManagement2 = _interopRequireDefault(_TeamManagement);

var _ReferModal = require('../user/account/referral/ReferModal');

var _ReferModal2 = _interopRequireDefault(_ReferModal);

var _ReferralRedirect = require('../user/account/referral/ReferralRedirect');

var _ReferralRedirect2 = _interopRequireDefault(_ReferralRedirect);

var _AccountModalRoot = require('../user/account/AccountModalRoot');

var _AccountModalRoot2 = _interopRequireDefault(_AccountModalRoot);

var _UnsubscribeModal = require('../user/account/unsubscribe/UnsubscribeModal');

var _UnsubscribeModal2 = _interopRequireDefault(_UnsubscribeModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * route.js
 *  - Builds the routes for the application.
 */


// Components
// Lib
exports.default = _react2.default.createElement(
    _reactRouter.Route,
    { component: _AppInitContainer2.default },
    _react2.default.createElement(_reactRouter.Route, { path: '/login', component: _Login2.default }),
    _react2.default.createElement(_reactRouter.Route, { path: '/register', component: _Register2.default }),
    _react2.default.createElement(_reactRouter.Route, { path: '/forgotten-password', component: _ForgottenPasswordModal2.default }),
    _react2.default.createElement(_reactRouter.Route, { path: '/change-password', component: _ChangePasswordModal2.default }),
    _react2.default.createElement(_reactRouter.Route, { path: '/unsubscribe', component: _EmailUnsubscribeFullscreenModal2.default }),
    _react2.default.createElement(_reactRouter.Redirect, { from: '/account/unsubscribe', to: '/unsubscribe' }),
    _react2.default.createElement(_reactRouter.Route, { path: '/static/(:page)', component: _StaticPage2.default }),
    _react2.default.createElement(_reactRouter.Route, { path: '/refer/(:referrer)', component: _ReferralRedirect2.default }),
    _react2.default.createElement(_reactRouter.Redirect, { from: '/account', to: '/account/plan' }),
    _react2.default.createElement(
        _reactRouter.Route,
        { path: '/', component: _WorkspaceInitContainer2.default },
        _react2.default.createElement(
            _reactRouter.Route,
            { path: '/account', component: _AccountModalRoot2.default },
            _react2.default.createElement(_reactRouter.Route, { path: 'plan', component: _CurrentPlan2.default }),
            _react2.default.createElement(_reactRouter.Route, { path: 'card', component: _UpdateCardModal2.default }),
            _react2.default.createElement(_reactRouter.Route, { path: 'refer', component: _ReferModal2.default }),
            _react2.default.createElement(_reactRouter.Route, { path: 'cancel', component: _UnsubscribeModal2.default }),
            _react2.default.createElement(_reactRouter.Route, { path: 'payment', component: _Payment2.default }),
            _react2.default.createElement(_reactRouter.Route, { path: 'team', component: _TeamManagement2.default }),
            _react2.default.createElement(_reactRouter.Route, { path: 'settings', component: _AccountSettingsModal2.default })
        ),
        _react2.default.createElement(_reactRouter.Route, { path: '/:currentBoardId(/:slug)', component: _CurrentBoardIdSynchroniser2.default })
    )
);
// import AuthenticatedContainer from '../auth/AuthenticatedContainer';


//////////////////
// WEBPACK FOOTER
// ./src/client/app/routes.js
// module id = 1669
// module chunks = 0